export const GET_SERVICE_DETAIL = "GET_SERVICE_DETAIL"
export const getServiceDetail = id => ({
  type: GET_SERVICE_DETAIL,
  payload: id,
})

export const STORE_SERVICE_DETAIL = "STORE_SERVICE_DETAIL"
export const storeServiceDetail = detail => ({
  type: STORE_SERVICE_DETAIL,
  payload: detail,
})

export const STORE_ERROR_MESSAGE = "STORE_ERROR_MESSAGE"
export const storeErrorMessage = message => ({
  type: STORE_ERROR_MESSAGE,
  payload: message,
})

export const STORE_API_LOADING = "STORE_API_LOADING"
export const storeApiLoading = status => ({
  type: STORE_API_LOADING,
  payload: status,
})
